import { render, staticRenderFns } from "./ProductPoints.vue?vue&type=template&id=fecf64ee"
import script from "./ProductPoints.vue?vue&type=script&lang=js"
export * from "./ProductPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports